var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91615 4.49993L9.80995 8.00453C10.0634 8.23249 10.0634 8.60107 9.80995 8.82903C9.55667 9.05699 9.14714 9.05699 8.89386 8.82903L4.99994 5.32443L1.10614 8.82903C0.85274 9.05699 0.443335 9.05699 0.190051 8.82903C-0.0633505 8.60107 -0.0633505 8.23249 0.190051 8.00453L4.08385 4.49993L0.190051 0.995335C-0.0633505 0.767375 -0.0633505 0.398796 0.190051 0.170836C0.316278 0.0571232 0.482246 0 0.648097 0C0.813947 0 0.979797 0.0571232 1.10614 0.170836L4.99994 3.67544L8.89386 0.170836C9.0202 0.0571232 9.18605 0 9.3519 0C9.51775 0 9.6836 0.0571232 9.80995 0.170836C10.0634 0.398796 10.0634 0.767375 9.80995 0.995335L5.91615 4.49993Z",
    fill: "#FF0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.96087dfe79b079b39b9198ec63a03ba3.svg";
export { ForwardRef as ReactComponent };